import React, {Component} from 'react'
import {_getIAAMinimumAccounts} from "../../../../../../services/apis/WorkerServices"

class IAAMinimumAccounts extends Component {
    state = {
        total: 0
    }

    _refresh = null

    componentDidMount() {
        this._fetchMinimumAccounts()
        this._refresh = setInterval(() => {
            this._fetchMinimumAccounts()
        }, 20000)
    }

    componentWillUnmount() {
        this._refresh && clearInterval(this._refresh)
    }

    _fetchMinimumAccounts = async () => {
        const {data, success} = await _getIAAMinimumAccounts()

        if (success) {
            this.setState({
                total: data
            })
        }
    }

    render() {
        return (
            <div className="IAASpeed">
                <strong>Minimum:</strong>
                <span className="Number"> {this.state.total} workers</span>
            </div>
        )
    }
}

export default IAAMinimumAccounts



// WEBPACK FOOTER //
// ./src/app/pages/dashboard/workers/components/iaa/IAAMinimumAccounts.js